"use client";

import { clsx } from "@trydig/ui";
import type { PropsWithChildren } from "react";
import type { HeroCardStoryblok } from "~/generated/sb/blok-types";
import styles from "./HeroSliderBlok.module.css";
import { useHeroSlider } from "./useHeroSlider";

export const Slider = ({
	children,
	media,
}: PropsWithChildren<{
	media: HeroCardStoryblok[];
}>) => {
	const { emblaRef, scrollTo, scrollSnaps, selectedIndex } = useHeroSlider({
		images: media,
	});
	return (
		<div className={styles.embla} ref={emblaRef}>
			<div className={styles.embla__container}>{children}</div>
			<nav className={styles.dot__gallery}>
				{scrollSnaps.length > 1 &&
					scrollSnaps.map((_, index) => (
						<button
							className={clsx(
								styles["dot-button"],
								index === selectedIndex && styles["is-selected"],
							)}
							key={index}
							onClick={() => scrollTo(index)}
						>
							<span className={styles.dot} />
						</button>
					))}
			</nav>
		</div>
	);
};
